import Api from '@/helpers/api';

const getAllConnections = async () => {
    try {
        const result = await Api.get('/connections');
        return result.data;
    } catch (error) {
        console.log("Error: getConnections ",error);
        return [];
    }
}

const getOneConnection = async (id) => {
    try {
        const result = await Api.get(`/connections/${id}`);
        return result.data;
    } catch (error) {
        console.log("Error: getOneConnection ",error);
        return [];
    }
}

const getTablesConnection = async (connectionID) => {
    try {        
        const result = await Api.post(`/connections/meta`, { connectionID });
        return result.data;
    } catch (error) {
        console.log("Error: getTablesConnection ", error);
        return [];
    }
}

const getRecordsTable = async (connectionID, tableName) => {
    try {        
        const result = await Api.post(`/connections/meta`, { connectionID, tableName });
        return result.data;
    } catch (error) {
        console.log("Error: getRecordsTable ", error);
        return [];
    }
}

export { 
    getAllConnections, 
    getOneConnection, 
    getTablesConnection, 
    getRecordsTable 
}